var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { manageService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var SensitiveWordService = /** @class */ (function (_super) {
    __extends(SensitiveWordService, _super);
    function SensitiveWordService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询全部敏感词
     */
    SensitiveWordService.prototype.findAllSensitiveWord = function (data, page, sort, loading) {
        return this.netService.send({
            server: manageService.sensitiveWordController.findAllSensitiveWord,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 新增敏感词
     */
    SensitiveWordService.prototype.addSensitiveWord = function (data, loading) {
        return this.netService.send({
            server: manageService.sensitiveWordController.addSensitiveWord,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改敏感词
     */
    SensitiveWordService.prototype.modifySensitiveWord = function (data, loading) {
        return this.netService.send({
            server: manageService.sensitiveWordController.modifySensitiveWord,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除敏感词
     */
    SensitiveWordService.prototype.deleteSensitiveWord = function (id, loading) {
        return this.netService.send({
            server: manageService.sensitiveWordController.deleteSensitiveWord,
            data: {
                id: id
            },
            loading: loading
        });
    };
    /**
     * 查询未配置敏感词的委托方
     */
    SensitiveWordService.prototype.getPrincipalNoWordConfig = function (loading) {
        return this.netService.send({
            server: manageService.sensitiveWordController.getPrincipalNoWordConfig,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], SensitiveWordService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], SensitiveWordService.prototype, "findAllSensitiveWord", null);
    __decorate([
        Debounce()
    ], SensitiveWordService.prototype, "addSensitiveWord", null);
    __decorate([
        Debounce()
    ], SensitiveWordService.prototype, "modifySensitiveWord", null);
    __decorate([
        Debounce()
    ], SensitiveWordService.prototype, "deleteSensitiveWord", null);
    __decorate([
        Debounce()
    ], SensitiveWordService.prototype, "getPrincipalNoWordConfig", null);
    return SensitiveWordService;
}(Service));
export { SensitiveWordService };
